<template>
  <ImpressaoModal
    header="orientação Médica"
    :ref="refs"
    size="lg"
    :pageSelect="true"
    @acao="imprimirorientacao"
    @changedata="updateDados"
    idModal="orientacaomodalimpressao"
  >
    <HTMLReport v-if="dados" id="imprimir-orientacao" :header="true" v-show="false" :pageSize="pageSize">
      <div>
        <br />
        <h2 class="text-center" style="width: 90%;">
          <strong>{{ dados.st_titulo }}</strong>
        </h2>
        <br />
        <template v-if="paciente">
          <div v-if="paciente">
            Nome: <strong>{{ paciente.st_nome }}</strong>
          </div>
          <div>
            Data: <strong>{{ $util.getFormatDate(dados.dt_inclusao) }}</strong>
          </div>
        </template>
        <br />
        
        <template v-if="dados.fl_formulario && dados.layout_impressao"> 
          <div style="width: 90%;">
            <formulario v-model="dados.layout_impressao" mode="view" :printing="true" /> 
          </div>
        </template>

        <template v-else-if="dados.fl_formulario"> 
          <formulario v-model="dados.estrutura" mode="view" :printing="true" />
        </template>

        <template v-else-if="dados.texto_html">
          <div v-html="dados.texto_html"></div>
        </template>

        <template v-else>
          <div v-if="dados.st_descricao" class="mx-2">{{ dados.st_descricao }}</div>
        </template>

      </div>
      <template v-slot:rodape v-if="medico">
        <rodape-medico :medico="medico" />
      </template>
    </HTMLReport>
  </ImpressaoModal>
</template>

<script>
import HTMLReport from "../HTMLReport";
import * as moment from "moment";
import ImpressaoModal from "../shared/ModalImpressao";
import Formulario from '../../modulos/consultorio/Formulario.vue';
import RodapeMedico from "./RodapeMedico.vue";

//import "../../../../public/estilosimpressao/estilosa4.css";
//import "../../../../public/estilosimpressao/estilosa5.css";

export default {
  data() {
    return {
      unidade: null,
      pageSize: "",
      dados: {}
    };
  },
  props: ["documento", "paciente", "medico"],

  components: { 
    HTMLReport, 
    ImpressaoModal,
    Formulario,
    RodapeMedico
  },

  methods: {
    assinaturaReport() {
      return (
        ( this.unidade.endereco ? ( this.unidade.endereco.cidade.st_cidade + ",  " ) : "" ) +
        moment().format("DD [de] MMMM [de] YYYY")
      );
    },
    abrirModal(dadosIniciais) {
      this.dados = dadosIniciais;
      console.log("dados orientação", dadosIniciais);
      this.pageSize = this.$refs[this.refs].dados.pageSize;
      // this.$refs[this.refs].abrirModalImpressao();
      this.$nextTick(() => {
        this.$refs[this.refs].abrirModalImpressao();
      });
    },
    imprimirorientacao(dados) {
      this.pageSize = this.$util.getCookie('page-size');
      this.dados = dados;
      let configPrint;
      if (this.pageSize === "A4") {
        configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
            "https://api.klingo.app/css/estiloa4.css"
          ]
        };
      } else if (this.pageSize === "A5") {
        configPrint = {
          styles: [
            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
            "https://api.klingo.app/css/estiloa5.css"
          ]
        };

        console.log('CP', configPrint);

        //"https://api.klingo.app/css/estiloa4.css",
        //"https://api.klingo.app/css/estiloa5.css",
        //"./estilosimpressao/estilosa5.css"
      }

      this.$nextTick(() => {
        this.$htmlToPaper("imprimir-orientacao", configPrint, () => {});
      });
    },
    updateDados(dados) {
      this.pageSize = dados.pageSize;
    }
  },
  computed: {
    // styleView() {
    //   if (this.pageSize == "A4") {
    //     return "width:210 mm; height: 297mm;";
    //   } else {
    //     return "width:148 mm; height: 210mm;";
    //   }
    // },
    refs() {
      return this.$util.gerarRandomString(9, "modalorientacao");
    }
  },
  mounted() {
    this.unidade = this.$store.state.unidade;
  }
};
</script>
